import SelectHotelInput from "@/components/form/SelectHotelInput";
import { SelectedHotel } from "@/components/form/SelectHotelInput";
import { getGroup } from "@/services/groups";
import { createCollection, iCollection } from "@/services/collection";
import { fireTagManagerEvent } from "@/services/tagmanager";
import { fireJuneEvent } from "@/components/analytics/JuneAnalytics";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
  collection: iCollection;
  userEmail: string | null;
};

const AddCollectionForm = (props: Props) => {
  const { t } = useTranslation();
  const { collection, userEmail } = props;

  const navigate = useNavigate();

  const handleCreateCollection = async () => {
    try {
      const group = await getGroup(collection.groupId);

      console.log("group: ", group);

      const new_collection = await createCollection({
        groupId: group?._id,
        name: SelectedHotel.value.dest_name,
      });

      fireTagManagerEvent("create_collection", {
        collectionName: new_collection.name,
        email: userEmail,
      });

      fireJuneEvent("add_collection", {
        collectionName: new_collection.name,
        collectionType: new_collection.type,
        collectionId: new_collection._id,
      });

      navigate(`/collection/${new_collection._id}/taks`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col">
      <SelectHotelInput
        onSubmit={handleCreateCollection}
        buttonLabel={t("collection.confirm_role_button")}
      />
    </div>
  );
};

export default AddCollectionForm;
